import styled from 'styled-components';
import Container from 'js/components/core/ReviewPanel/Container';

export default styled(Container)`
  margin-top: 2rem;
`;
